import {
  PageConfig,
  PageConfigField,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth } from "../../blocks/layout/columnSpans";
import {
  audienceEntityRadioOptions,
  audienceRunAtRadioOptions,
  audienceTypeOptions,
} from "./communicationAudienceRecord";

// Regarding and Run At decide which rules exist, so they are open only until the audience
// is saved or has a rule.
const audienceFields = (locked: boolean): PageConfigField[] => [
  {
    id: "field-g4c_name",
    type: "text",
    name: "g4c_name",
    label: "Name",
    required: true,
    isNameField: true,
    span: fullWidth,
  },
  {
    id: "field-g4c_communicationaudiencetype",
    type: "radio",
    name: "g4c_communicationaudiencetype",
    label: "Type",
    cards: true,
    inline: true,
    options: audienceTypeOptions,
    span: fullWidth,
  },
  {
    id: "field-g4c_entitytype",
    type: "radio",
    name: "g4c_entitytype",
    label: "Regarding",
    cards: true,
    inline: true,
    options: audienceEntityRadioOptions,
    readOnly: locked,
    span: fullWidth,
  },
  {
    id: "field-g4c_runat",
    type: "radio",
    name: "g4c_runat",
    label: "Run At",
    cards: true,
    inline: true,
    options: audienceRunAtRadioOptions,
    readOnly: locked,
    visibleWhen: "warehouseAudienceEnabled",
    span: fullWidth,
  },
];

/**
 * Communication Audience as page config. The audience's details fill the
 * body's right dock until a rule is selected; the body lays the rules out beside it, so the last row is declared
 * here only for its field to be validated. The audience section is the new-record
 * wizard's one step.
 */
export const communicationAudiencePageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "g4c_communicationaudience",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-audience",
      columns: [
        {
          id: "column-audience",
          span: fullWidth,
          card: true,
          blocks: [
            {
              kind: "section",
              id: "section-audience",
              title: "Details",
              wizardStep: true,
              visibleWhen: "audienceUnlocked",
              fields: audienceFields(false),
            },
            {
              kind: "section",
              id: "section-audience-locked",
              title: "Details",
              visibleWhen: "audienceLocked",
              fields: audienceFields(true),
            },
          ],
        },
      ],
    },
    {
      id: "row-rules",
      columns: [
        {
          id: "column-rules",
          span: fullWidth,
          blocks: [
            {
              kind: "section",
              id: "section-rules",
              title: "Rules",
              fields: [
                {
                  id: "field-rule_data",
                  type: "component",
                  name: "rule_data",
                  label: "",
                  componentKey: "communicationAudienceRules",
                  validatorKey: "communicationAudienceRules",
                  showsOwnErrors: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
